var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeasingIconAdv4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30912 17.0052L6.30916 17.0052L24.9998 6.09957L43.6905 17.0052L43.6906 17.0052C44.9223 17.7233 45.6832 19.047 45.6832 20.4726V41.3588C45.6832 43.5532 43.8609 45.3755 41.6665 45.3755H8.33317C6.1388 45.3755 4.3165 43.5532 4.3165 41.3588V20.4726C4.3165 19.047 5.07742 17.7233 6.30912 17.0052ZM25.0754 10.6222L24.9998 10.5781L24.9243 10.6222L8.48139 20.2128L8.26635 20.3383L8.47773 20.4698L24.9206 30.6993L24.9998 30.7486L25.0791 30.6993L41.5219 20.4698L41.7333 20.3383L41.5183 20.2128L25.0754 10.6222ZM8.4124 24.9839L8.18317 24.8413V25.1113V41.3588V41.5088H8.33317H41.6665H41.8165V41.3588V25.1113V24.8413L41.5873 24.9839L24.9998 35.3025L8.4124 24.9839Z",
    fill: "#646AFF",
    stroke: "#F5F5F5",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeasingIconAdv4);
export default __webpack_public_path__ + "static/media/leasing-icon-adv-4.3483da48bc5f27e937c18e5845ad6c15.svg";
export { ForwardRef as ReactComponent };